import { Canvas } from '@react-three/fiber';
import { Suspense } from 'react';
import { GlobeModel } from '@/components/molecules/GlobeModel';

/**
 * GlobeWrapper Component
 *
 * Wraps the animated 3D globe in a Three.js Canvas for the login page.
 * Part of AuthHero organism in Atomic Design structure.
 */
export const GlobeWrapper = () => {
  return (
    <div className="absolute top-1/2 -translate-y-1/2 w-full h-full">
      <Canvas className="canvas" camera={{ position: [-3.5, 0, 0], fov: 60 }}>
        <Suspense fallback={null}>
          <GlobeModel />
        </Suspense>
      </Canvas>
    </div>
  );
};
